import { useUser } from '@clerk/clerk-react'
import { useCurrentMedication } from '@/hooks/useCurrentMedication'
import { calculateTotalHoldReasonLength } from '@/lib/utils'

const CharacterCounter = ({ message, type }: { message: string; type: 'hold' | 'rejection' }) => {
  const { user } = useUser()
  const medRequest = useCurrentMedication()

  if (!user || !medRequest?.data) {
    return null
  }

  const existingReason =
    type === 'rejection' ? (medRequest.data.reasonForRejection ?? null) : medRequest.data.reasonForHold

  const totalLength = calculateTotalHoldReasonLength(message, existingReason, `${user.firstName} ${user.lastName}`)

  const remainingChars = 1950 - totalLength
  const isNearLimit = remainingChars <= 100
  const isOverLimit = remainingChars < 0

  return (
    <div className={`text-xs mt-2 ${isOverLimit ? 'text-red-500' : isNearLimit ? 'text-orange-500' : 'text-gray-500'}`}>
      {isOverLimit ? (
        <span className='block text-red-600 font-medium'>Message too long! Please shorten your message.</span>
      ) : (
        <span className='block text-gray-500 font-medium'>{`${remainingChars} characters remaining`}</span>
      )}
    </div>
  )
}

export default CharacterCounter
